import { Pais } from './Pais';
import { Universitat } from './universitat';
import { Estudi } from './estudi';

export class EstudisRealitzats {
    constructor(
        public pais: Pais = null,
        public universitat: Universitat = null,
        public universitatText: string = null,
        public estudi: Estudi = null,
        public estudiText: string = null,
        public notaMitjana: number = null) {
    }

    paisEspanya(): boolean {
        if (this.pais == null) {
            return false;
        }
        return this.pais.value === 72;
    }

    universitatGirona(): boolean {
        if (this.universitat == null) {
            return false;
        }
        return this.universitat.value === 25;
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/model/estudiRealitzat.ts